<div class="files-item-list" uploadFile (onFileDropped)="uploadFile($event); saveFiles = false">
  <div class="new-file-item">
    <label class="label-file" [for]="'select-file' + index"
      ><i class="far fa-cloud-arrow-up fa-lg"></i> NOVO ANEXO PARA O ITEM</label
    >
    <input
      type="file"
      [id]="'select-file' + index"
      style="display: none"
      (change)="handleFileSelection($event.target.files); saveFiles = false"
    />
  </div>
  <ng-container *ngFor="let file of uploadedFiles; index as indexOfFile">
    <div class="file-card cursor-pointer" (click)="openFile(file)">
      <div class="col text-start d-flex flex-column justify-content-between py-2">
        <div class="row mx-0 d-flex align-items-center mt-2">
          <span class="file-name-overflow">
            {{ file?.file?.name ?? file?.file?.originalName }}
          </span>
        </div>
        <div class="col-auto px-0">
          <small style="font-size: 14px" class="row mx-0 text-muted my-1">
            {{ (file?.file?.type ?? file?.file?.mimeType).split('/')[1].toUpperCase() }}
          </small>
          <small style="font-size: 14px" class="row mx-0 text-muted">
            {{ file?.file?.size ?? file?.file?.size | fileSize }}
          </small>
        </div>
      </div>
      <div class="pt-3" (click)="$event.stopPropagation()">
        <div class="col text-right">
          <i
            *ngIf="!saveFiles"
            class="fa-solid fa-x text-muted mt-2 action-btn"
            (click)="removeFile(file?.file?.name ?? file?.file?.originalName)"
            style="cursor: pointer"
          ></i>
        </div>
      </div>
    </div>
  </ng-container>
</div>
